var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5545_22065)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "url(#paint0_linear_5545_22065)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.0001 23.6395C8.84883 23.6392 5.82416 22.3993 3.57936 20.1877C1.33455 17.9761 0.0497915 14.9702 0.00256348 11.8193C0.00256348 11.8801 0.00256348 11.9434 0.00256348 12.0004C0.00256348 15.183 1.26685 18.2353 3.51728 20.4857C5.76772 22.7361 8.81997 24.0004 12.0026 24.0004C15.1847 23.9998 18.2363 22.7352 20.4862 20.4848C22.7361 18.2345 24.0001 15.1826 24.0001 12.0004C24.0001 11.9396 24.0001 11.8764 24.0001 11.8193C23.9532 14.9708 22.6682 17.9772 20.4228 20.189C18.1774 22.4007 15.1519 23.6402 12.0001 23.6395Z",
    fill: "#FDF356"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.450233C15.1434 0.450327 18.1613 1.68386 20.4049 3.88564C22.6484 6.08742 23.9384 9.08161 23.9975 12.2245C23.9975 12.1501 23.9975 12.0744 23.9975 12C23.9977 10.4241 23.6874 8.86359 23.0844 7.40761C22.4814 5.95162 21.5975 4.62869 20.4832 3.51436C19.3688 2.40002 18.0459 1.51611 16.5899 0.913116C15.1339 0.310118 13.5734 -0.000162846 11.9975 6.41174e-08C8.81535 0.000657877 5.76374 1.26523 3.51384 3.51559C1.26394 5.76596 -6.7991e-08 8.81783 0 12C0 12.0744 0 12.1501 0 12.2245C0.0588233 9.08108 1.34907 6.08633 3.59319 3.88441C5.83732 1.6825 8.85603 0.449358 12 0.450233Z",
    fill: "#FDF356"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M12 23.944C18.5966 23.944 23.9442 18.5964 23.9442 11.9999C23.9442 5.40326 18.5966 0.0556641 12 0.0556641C5.40338 0.0556641 0.0557861 5.40326 0.0557861 11.9999C0.0557861 18.5964 5.40338 23.944 12 23.944Z",
    fill: "url(#paint1_radial_5545_22065)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.7,
    d: "M12 0.0449219C8.88723 0.045063 5.8974 1.25985 3.66668 3.43081C1.43596 5.60177 0.140438 8.55751 0.0557861 11.6691C1.37672 12.453 3.45424 11.8254 4.81362 11.1469C5.98075 10.6074 7.41827 10.7872 8.67594 10.8765C11.8201 11.1469 14.8775 12.489 18.0192 11.6852C18.648 11.5054 19.5473 10.693 20.1761 11.2362C20.6961 11.6627 21.3275 11.931 21.9954 12.0093C22.6633 12.0875 23.3397 11.9725 23.9442 11.6778C23.862 8.56457 22.5676 5.60645 20.3366 3.43357C18.1055 1.26069 15.1143 0.044809 12 0.0449219Z",
    fill: "url(#paint2_linear_5545_22065)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 21.2933C17.1327 21.2933 21.2936 17.1324 21.2936 11.9997C21.2936 6.86696 17.1327 2.70605 11.9999 2.70605C6.86721 2.70605 2.7063 6.86696 2.7063 11.9997C2.7063 17.1324 6.86721 21.2933 11.9999 21.2933Z",
    fill: "url(#paint3_linear_5545_22065)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.8425C16.8834 20.8425 20.8422 16.8838 20.8422 12.0004C20.8422 7.11698 16.8834 3.1582 12 3.1582C7.11661 3.1582 3.15784 7.11698 3.15784 12.0004C3.15784 16.8838 7.11661 20.8425 12 20.8425Z",
    fill: "#EE9B00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.481C16.6841 20.481 20.4813 16.6839 20.4813 11.9998C20.4813 7.31573 16.6841 3.51855 12 3.51855C7.31598 3.51855 3.5188 7.31573 3.5188 11.9998C3.5188 16.6839 7.31598 20.481 12 20.481Z",
    fill: "url(#paint4_radial_5545_22065)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M12 19.8488C7.39223 19.8488 3.64153 16.3536 3.52246 11.7744C3.52246 11.8488 3.52246 11.9245 3.52246 12.0001C3.52279 14.2494 4.41645 16.4065 6.00692 17.9969C7.59739 19.5874 9.75444 20.4811 12.0037 20.4814C14.2531 20.4814 16.4103 19.5878 18.0008 17.9973C19.5914 16.4068 20.4849 14.2495 20.4849 12.0001C20.4849 11.9245 20.4849 11.8488 20.4849 11.7744C20.3584 16.3536 16.609 19.8488 12 19.8488Z",
    fill: "#FDF356"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5545_22065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.625 15.8154H12.975C13.32 15.8154 13.6 16.1048 13.6 16.4615C13.6 16.8182 13.32 17.1077 12.975 17.1077H10.625C10.28 17.1077 10 16.8182 10 16.4615C10 16.1048 10.28 15.8154 10.625 15.8154Z",
    fill: "#FFF746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45387 13.2308H14.5462C14.9071 13.2308 15.2 13.5202 15.2 13.8769C15.2 14.2336 14.9071 14.5231 14.5462 14.5231H9.45387C9.09295 14.5231 8.80002 14.2336 8.80002 13.8769C8.80002 13.5202 9.09295 13.2308 9.45387 13.2308Z",
    fill: "#FFF746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.23891 10.6461H15.7611C16.1138 10.6461 16.4 10.9356 16.4 11.2923C16.4 11.649 16.1138 11.9384 15.7611 11.9384H8.23891C7.88625 11.9384 7.60002 11.649 7.60002 11.2923C7.60002 10.9356 7.88625 10.6461 8.23891 10.6461Z",
    fill: "#FFF746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03046 8.06152H16.9696C17.3176 8.06152 17.6 8.351 17.6 8.70768C17.6 9.06435 17.3176 9.35383 16.9696 9.35383H7.03046C6.68246 9.35383 6.40002 9.06435 6.40002 8.70768C6.40002 8.351 6.68246 8.06152 7.03046 8.06152Z",
    fill: "#FFF746"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5545_22065",
    x: 6.40002,
    y: 8.06152,
    width: 11.2,
    height: 9.5459,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.933333 0 0 0 0 0.607843 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5545_22065"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5545_22065",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5545_22065",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8DF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FCE900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFEF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3A700"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5545_22065",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.8797 -1.651) scale(9.55659)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF77D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5545_22065",
    x1: 12,
    y1: 22.0021,
    x2: 12,
    y2: 4.58818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5545_22065",
    x1: 11.9999,
    y1: 21.2933,
    x2: 11.9999,
    y2: -1.54201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FDD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F7B900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5AE00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_5545_22065",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.0906 4.69189) scale(17.053)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#FFDF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3A700"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5545_22065"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.0cacd7a37fe3f045cf80b71d3a82801d.svg";
export { ForwardRef as ReactComponent };